import * as React from "react";
const SvgMansion = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M12 8a1 1 0 0 0-1 1v1a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1Z"
      fill="currentColor"
    />
    <path
      d="M12.516 2.206a.75.75 0 0 0-1.032 0L10.646 3H4c-.317 0-.6.2-.706.498l-1.25 3.5A.75.75 0 0 0 2.75 8H3v10.264c-.614.55-1 1.347-1 2.236v.15c0 .746.604 1.35 1.35 1.35h17.3A1.35 1.35 0 0 0 22 20.65v-.15c0-.889-.386-1.687-1-2.236V8h.25a.75.75 0 0 0 .706-1.002l-1.25-3.5A.75.75 0 0 0 20 3h-6.646l-.838-.794ZM5 17.5c-.17 0-.337.014-.5.041V8h2v9.901A2.987 2.987 0 0 0 5 17.5Zm3 3V7.573l4-3.79 4 3.79V20.5h-1v-4.423C15 14.4 13.68 13 12 13s-3 1.401-3 3.077V20.5H8ZM5 19a1.5 1.5 0 0 1 1.5 1.5h-3A1.5 1.5 0 0 1 5 19Zm14.5-1.459a3.018 3.018 0 0 0-2 .36V8h2v9.541Zm1 2.959h-3a1.5 1.5 0 0 1 3 0Zm-5.562-16h4.533l.715 2h-3.137l-2.111-2Zm-7.987 2H3.814l.715-2h4.533l-2.11 2Zm5.049 8c.805 0 1.5.682 1.5 1.577V20.5h-3v-4.423c0-.895.695-1.577 1.5-1.577Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgMansion;
